import React, { useEffect, useState } from "react";
import {
  Table,
  Tag,
  Space,
  Button,
  Modal,
  Form,
  Input,
  notification,
  Select,
} from "antd";
import {
  viewUsersAction,
  addUserAction,
  resetPassword
} from "../../redux/actions/authActions";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const { Option } = Select;

const UserManagement = ({
  viewUsersAction,
  addUserAction,
  resetPassword,
  usersState,
  newAdminState,
  match,
}) => {
  const [isLoading, setLoader] = useState(true);
  const [form] = Form.useForm();
  const { confirm } = Modal;

  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [newAdminData, setNewAdminData] = useState({});

  const courseName = match.params.courseName;




  const columns = [
    {
      title: "S/N",
      dataIndex: "sn",
      key: "sn",
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Role",
      key: "role",
      dataIndex: "role",
      render: (role) => (
        <>
          {role.map((role) => {
            let color = role.length > 5 ? "geekblue" : "green";
            if (role === "N/A") {
              color = "volcano";
            }
            return (
              <Tag color={color} key={role}>
                {role.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Date added",
      dataIndex: "dateAdded",
      key: "dateAdded",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
  
        return (
          <>
            <Space size="middle">
              <a>Edit</a>
              <a onClick={()=>handlerReset(record._id)}>Reset-Pswd</a>
            </Space>
          </>
        );
      },
    },
  ];
  const handlerReset=(dataId)=>{
    console.log("reseteddddd",dataId);
    resetPassword(dataId);
  }




  const getAllModules = () => {
    viewUsersAction();
  };
  useEffect(() => {
    getAllModules();
    if (usersState.viewUsersData) {
      setLoader(false);
    }
  }, []);

  const users = usersState.viewUsersData?.data.map((user, i) => {
    const role = user.role?.split(",") || ["N/A"];
    return {
      sn: i + 1,
      _id:user._id,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      role,
      dateAdded: user.createdAt,
    };
  });

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setConfirmLoading(true);

    addUserAction(newAdminData);
    console.log(newAdminData);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  useEffect(() => {
    viewUsersAction();
    // if (courseState.allCoursesData) {
    setLoading(false);
    // }
    if (newAdminState.newAdminData) {
      setVisible(false);
      setConfirmLoading(false);
      setNewAdminData({});
      form.resetFields();
      notification.success({ message: "Invitation sent successfully" });
    }
    if (newAdminState.newAdminError) {
      setConfirmLoading(false);
      notification.error({ message: newAdminState.newAdminError.error[0] });
    }
  }, [newAdminState]);

  return (
    <>
      <Space style={{ marginBottom: 16 }}>
        <Button
          type="primary"
          size="large"
          onClick={showModal}
          htmlType="submit"
        >
          NEW USER
        </Button>
      </Space>
      {/* New course modal */}
      <Modal
        title="Invite an admin"
        visible={visible}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        okText="Invite"
        okButtonProps={{ htmlType: "submit" }}
      >
        <Form
          form={form}
          layout="vertical"
          hideRequiredMark
          className="mb-4"
          initialValues={{ email: null, password: null }}
        >
          <Form.Item
            name="firstName"
            rules={[
              {
                required: true,
                message: "Please provide new admin first name",
              },
            ]}
          >
            <Input
              size="large"
              type="text"
              placeholder="First Name"
              onChange={(e) =>
                setNewAdminData({ ...newAdminData, firstName: e.target.value })
              }
            />
          </Form.Item>
          <Form.Item
            name="lastName"
            rules={[
              { required: true, message: "Please provide new admin last name" },
            ]}
          >
            <Input
              size="large"
              type="text"
              placeholder="Last Name"
              onChange={(e) =>
                setNewAdminData({ ...newAdminData, lastName: e.target.value })
              }
            />
          </Form.Item>
          <Form.Item
            name="role"
            rules={[{ required: true, message: "Please provide the role" }]}
          >
            <Select
              defaultValue=""
              onChange={(value) =>
                setNewAdminData({ ...newAdminData, role: value })
              }
            >
              <Option value="" disabled>
                Select user role
              </Option>
              <Option value="student">Student</Option>
              <Option value="admin">Admin</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              { required: true, message: "Please provide new user email" },
            ]}
          >
            <Input
              size="large"
              type="text"
              placeholder="Email"
              onChange={(e) =>
                setNewAdminData({ ...newAdminData, email: e.target.value })
              }
            />
          </Form.Item>
        </Form>
      </Modal>
      <Table
        title={() => <h2>Available users</h2>}
        columns={columns}
        dataSource={users}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    usersState: state.auth.viewUsers,
    newAdminState: state.auth.addUser,
  };
};

export default connect(mapStateToProps, { viewUsersAction, addUserAction,resetPassword })(
  UserManagement
);
